// Mismo contenido que el PDF aprobado (/app/docs/build_guia.py).
export const GUIA_SECCIONES = [
  {
    n: '0', titulo: 'Antes de empezar', donde: 'Pantalla: Edificios → elegir edificio',
    pasos: [
      'Ingresá con tu email y contraseña en la pantalla de inicio.',
      'Elegí el edificio con el que vas a trabajar (por ejemplo, <b>Torre Emilia</b>).',
      'Arriba vas a ver las solapas numeradas del <b>1</b> al <b>11</b>: seguí el orden de los números, es el orden del mes.',
      'En cada solapa, el <b>selector de mes</b> (flechas ‹ ›) define el período con el que trabajás.',
      '¿Dudas? Tocá el ícono <b>?</b> de ayuda para abrir esta guía.',
    ],
    tip: 'Todo se guarda solo; no hay botón “Guardar” en las tablas.',
    capturas: [['02_edificios.png', 'Listado de edificios']],
  },
  {
    n: '1', titulo: 'Cargar y revisar la facturación', donde: 'Solapa 5. Factura',
    pasos: [
      'Elegí el mes a facturar con el selector de mes.',
      'Revisá cada fila: <b>Neto Mes Ant.</b> (lo del mes pasado) contra <b>Monto Neto</b> (lo de este mes). Si hay una diferencia grande, revisá el contrato.',
      'Si una fila tiene un aviso en rojo (<b>Falta índice</b>, <b>Falta cotización</b>), cargá el dato que pide antes de seguir.',
      'Para corregir un monto, tocá el <b>lápiz</b> al lado del Monto Neto y escribí el valor. El IVA y el total se recalculan solos.',
      'Cuando la fila está bien, tocá <b>Aprobar</b>. Queda la fecha de aprobación.',
    ],
    tip: 'El IVA (21%) se suma siempre; la condición del cliente solo define si la factura es A o B.',
    capturas: [['03_factura.png', '5. Factura: revisar montos y aprobar']],
  },
  {
    n: '2', titulo: 'Emitir y enviar las facturas', donde: 'Solapa 5. Factura (columnas Facturas, PDF y Envía factura)',
    pasos: [
      'Con la fila aprobada, tocá <b>Emitir</b> para generar la factura electrónica en Colppy. El número lo asigna AFIP solo.',
      'Si la factura se hace afuera (manual), usá <b>Subir</b> y cargá el PDF.',
      'Verificá el comprobante con el ícono de la columna <b>PDF</b>.',
      'La primera vez, tocá <b>Configurar email</b> (al lado del mes) y completá email de respuesta, asunto, texto y datos bancarios.',
      'En la columna <b>Envía factura</b> tocá <b>Enviar</b>. Queda escrita la fecha de envío; si la reenviás, la app te pide confirmar.',
    ],
    tip: 'Si Colppy rechaza porque el cliente es “GRANDE”, la app reintenta sola como Factura de Crédito Electrónica MiPyME.',
    capturas: [['05_factura_der.png', 'Columnas Facturas, PDF y Envía factura'], ['04_config_email.png', 'Configurar email']],
  },
  {
    n: '3', titulo: 'Registrar los cobros', donde: 'Solapa 6. Cobro',
    pasos: [
      'Elegí el mes. Arriba ves cuántas facturas están pendientes, vencidas y cuánto se cobró.',
      'Cuando entra un pago, cambiá el <b>Estado</b> a <b>Cobrada</b> y cargá la <b>Fecha cobro</b> (dd/mm/aaaa).',
      'Si pagó una parte, cargá el <b>cobro parcial</b> (monto y fecha) en la fila; el saldo queda pendiente.',
      'Si corresponde, cargá una <b>bonificación</b> de intereses.',
      'El <b>semáforo</b> indica atraso: verde (día 1–10), amarillo (11–15), rojo (16 en adelante). Los atrasados aparecen en <b>7. Morosos</b>.',
    ],
    tip: '“Sincronizar con Colppy” trae los cobros ya registrados en Colppy.',
    capturas: [['06_cobro.png', '6. Cobro: estado, fecha y semáforo']],
  },
  {
    n: '4', titulo: 'Pagar a los propietarios', donde: 'Solapa 10. Pagos',
    pasos: [
      'Antes de pagar, confirmá que la liquidación del mes esté publicada en <b>9. Liquid.</b> (toma los gastos de <b>8. Egresos</b>).',
      'En <b>10. Pagos</b>, cada fila muestra propietario, % y resultado a pagar.',
      'Cuando el propietario te manda su factura, tocá <b>Subir</b> en <b>Factura propietario</b>. El estado pasa solo a <b>Pago pendiente</b>.',
      'Al transferir, tocá <b>Subir</b> en <b>Comprobante</b>. La fecha se completa sola (podés corregirla) y el estado pasa a <b>Pagado</b>.',
      'Sin factura del propietario el estado queda en <b>Falta factura</b>.',
    ],
    tip: 'El estado no se cambia a mano: depende de qué documentos están cargados.',
    capturas: [['09_pagos.png', '10. Pagos: factura del propietario, comprobante, fecha y estado']],
  },
  {
    n: '5', titulo: 'Cargar un contrato nuevo o una suscripción Cowork', donde: 'Solapa 3. Contratos → botón Nuevo contrato',
    pasos: [
      'Tocá <b>+ Nuevo contrato</b> arriba a la derecha.',
      'Elegí <b>Oficina</b> o <b>Cowork</b>.',
      '<b>Oficina:</b> en <b>Carga IA</b> subí el contrato (PDF o Word) y la app completa los datos. Revisá cada solapa: Unidades, Datos, Condiciones, Fiscal y Colppy (punto de venta).',
      'Tocá <b>Crear Contrato</b>.',
      '<b>Cowork:</b> elegí la unidad disponible, el tipo, nombre, CUIT, condición IVA y fecha de inicio; revisá el monto final y tocá <b>Dar de alta</b>.',
    ],
    tip: 'Para dar de baja un contrato usá Finalizar; después podés ver y corregir la fecha de baja en 4. Historial.',
    capturas: [['11_tipo_contrato.png', 'Elegir tipo de contrato'], ['12_contrato_form.png', 'Nuevo contrato de oficina con carga IA'], ['13_cowork_form.png', 'Alta de suscriptor Cowork']],
  },
];
